export interface Bonus {
  label: string
  title: string
  body: string
}

export const bonuses: Bonus[] = [
  {
    label: '🎁 BONUS 1',
    title: 'PRIVATE PILOT KNOWLEDGE CHECK™',
    body: 'Practice essential private pilot theory with organized knowledge questions, detailed answer explanations, topic-based review exercises, self-assessment activities, and knowledge gap tracking worksheets.',
  },
  {
    label: '🎁 BONUS 2',
    title: 'COCKPIT INSTRUMENT RECOGNITION CARDS™',
    body: 'Reinforce cockpit familiarization with printable instrument identification cards, labeled flight instrument illustrations, analog and digital display comparisons, interpretation exercises, and practical visual study references.',
  },
  {
    label: '🎁 BONUS 3',
    title: 'VFR FLIGHT PLANNING WORKBOOK™',
    body: 'Organize cross-country planning exercises with navigation logs, wind correction worksheets, fuel planning templates, aircraft performance calculation examples, weight and balance exercises, and educational VFR planning scenarios.',
  },
  {
    label: '🎁 BONUS 4',
    title: 'PRIVATE PILOT ORAL REVIEW & SCENARIO GUIDE™',
    body: 'Strengthen aviation knowledge with structured oral review questions, model answer outlines, realistic flight scenarios, technical discussion prompts, aeronautical decision-making exercises, and self-assessment worksheets.',
  },
  {
    label: '🎁 BONUS 5',
    title: '30-DAY PRIVATE PILOT STUDY PLANNER™',
    body: 'Organize your aviation studies with a structured 30-day learning schedule, daily topic assignments, progress trackers, knowledge review activities, personal study worksheets, and reusable revision planning tools.',
  },
]
